import { FC } from 'react';
import './SparePartsResultsCard.scss';

interface Part {
  id: string;
  partName: string;
  materialNumber: string;
  bom: string;
  category: string;
}

interface SparePartsResultsCardProps {
  title: string;
  parts: Part[];
}

const SparePartsResultsCard: FC<SparePartsResultsCardProps> = ({ title, parts }: SparePartsResultsCardProps) => {
  const columnHeaders = [
    { key: 'partName', label: 'Part Name' },
    { key: 'materialNumber', label: 'Material Number' },
    { key: 'bom', label: 'BOM' },
    { key: 'category', label: 'Category' },
  ];

  return (
    <div className="sparePartsResultsCard-container" data-testid="spare-parts-results">
      <div className="sparePartsResultsCard-title">{title}</div>
      
      <div className="sparePartsResultsCard-tableWrapper">
        <div className="sparePartsResultsCard-headerBackground"></div>
        <div className="sparePartsResultsCard-table">
          <div className="sparePartsResultsCard-headerRow">
            {columnHeaders.map((column) => (
              <div key={column.key} className="sparePartsResultsCard-column">
                <div className="sparePartsResultsCard-headerCell">{column.label}</div>
              </div>
            ))}
          </div>

          {parts.map((part) => (
            <div key={part.id} className="sparePartsResultsCard-dataRow">
              {columnHeaders.map((column) => (
                <div key={column.key} className="sparePartsResultsCard-column">
                  <div
                    className="sparePartsResultsCard-cell"
                    data-label={column.label}
                  >
                    {part[column.key as keyof Part]}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SparePartsResultsCard;
